<template>
  <div class="order-list-comp" v-if="giftList.length">
    <div class="gift-card" @click="navToGiftDetail(gift)" v-for="(gift, index) in giftList" :key="index">
      <img class="gift" :src="gift.img_url" />
      <div class="info-box">
        <div class="name">{{ gift.name }}</div>
        <div class="date">{{ service.formatOrderDateTime(gift.get_gift_time) }}</div>
      </div>
      <div class="status" :class="[gift.status]">{{ service.formatOrderStatusLabel(gift.status) }}</div>
    </div>
  </div>
  <p-e-empty-info v-else tip="还没有获得礼品哦~"></p-e-empty-info>
</template>
<script lang="ts">
import { BaseComponent, Component } from 'kuaidong-component'
import { GiftOrderStatus, IGiftOrderInfo } from 'kuaidong-model'
import { AGiftOrder } from 'kuaidong-api/src/AGiftOrder'
import { GiftOrderService } from 'kuaidong-service/src/GiftOrderService'
import PEEmptyInfo from '@/views/pe-class/components/PEEmptyInfo.vue'

@Component({
  components: {
    PEEmptyInfo,
  },
})
export default class OrderListComp extends BaseComponent {
  giftList: IGiftOrderInfo[] = []
  get service() {
    return GiftOrderService
  }

  async created() {
    this.fetchOrderList()
  }

  async fetchOrderList() {
    this.giftList = await AGiftOrder.list()
  }

  navToGiftDetail(giftOrder: IGiftOrderInfo) {
    if (giftOrder.status === GiftOrderStatus.NoAddress) {
      this.$router.push({
        name: 'select_my_gift_address',
        query: {
          addressInfo: JSON.stringify(giftOrder),
        },
      })
    } else {
      this.$router.push({
        name: 'gift_detail',
        query: {
          giftOrderId: giftOrder.gift_order_id,
        },
      })
    }
  }
}
</script>
<style lang="less">
.order-list-comp {
  display: flex;
  align-items: center;
  flex-direction: column;

  .gift-card {
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    margin-top: 16px;
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
    > .gift {
      width: 80px;
      height: 80px;
      margin-right: 8px;
    }
    > .info-box {
      width: 171px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      > .name {
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: #2d2f33;
        text-align: left;
      }

      > .date {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #4d4d4d;
      }
    }

    > .status {
      flex: 1;
      align-self: flex-start;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      &.no_address {
        color: #f24b53;
      }
      &.wait_shipped {
        color: #fe9647;
      }
      &.has_shipped {
        color: #3366ff;
      }
      &.cancel_shipment,
      &.cancel_order {
        color: #8f8f8f;
      }
    }
  }
}
</style>
